
import Checklist from 'vux/src/components/checklist/index.vue'

import { selectPlug } from "./js/plug";
import { selectDeviceName } from "./js/deviceName";
import { selectRoom } from "./js/room";
export default {
name: 'selection',
components: { Checklist },
data() {
return {
type: "", // 选择的类型
list: [],
isShow: false,
checkedVal: [], //是多选组件，用数组
onChangeFunction: null,  //选项改变时执行的后台的接口函数
defaultValue: '',
};
},
methods: {
/*------------------------------------------- 绑定函数 -------------------------------------------------------*/
/*  数据改变
* */
change() {
let selectedVal = this.checkedVal[0];        //checkedVal[0]就是所选值
if (selectedVal) {  //一开始值为[]，会变成undefined，所以会执行一次先
if (selectedVal !== this.defaultValue) {  //真正地值改变了
this.onChangeFunction(selectedVal).then(res => {
this.$emit('onChange', this.type);
}).catch(res => {
this.toast_fail();
});
setTimeout(() => {
this.isShow = false;
}, 500);
}
}
},
/*  是否显示组件，显示的话根据类型选择列表
* @param {str}type列表类型，比如连接电器，设备名称，所在房间等等
* @param {}defaultValue 默认值
* */
async showSelection(type, defaultValue) {
this.type = type;
if (!type) {  //空，隐藏
this.isShow = false;
} else {  //非空，选则数据
let selectItems = {};
let getVal = { //获取需要的列表，以及其默认值和点击函数
'plug':
function () {
selectItems = selectPlug;
},
'deviceName':
function () {
selectItems = selectDeviceName;
},
'room':
function () {
selectItems = selectRoom;
},
}[type]();

this.list = await selectItems.getList();
this.onChangeFunction = selectItems.onChangeFunction;
this.defaultValue = defaultValue;
this.checkedVal.push(defaultValue); //视图改变
this.isShow = true;
}
},
}
};



// WEBPACK FOOTER //
// ./src/pages/settings/Index_selection/index.vue